import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '../../../Button';
import Title from '../../../Title';
import DancingGran from '../../../../assets/images/DancingGran.gif';
import { sendAppLinkBySms } from '../../../../services/backendService';
import { getUserDetails } from '../../../../reducers/userDetails';
import { getAuthToken } from '../../../../reducers/auth';
import { getDealInfo } from '../../../../reducers/DealInfo';

class Summary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      oSName: ''
    };
    this.sendAppLink = this.sendAppLink.bind(this);
  }

  handleClickOnGooglePlayButton() {
    window.location.href = 'https://play.google.com/store/apps/details?id=com.venn.city';
  }

  sendAppLink() {
    const id = this.props.userDetails.get('data').get('id');
    sendAppLinkBySms(id, this.props.token);
  }

  componentDidMount() {
    const oSName = this.detectOs();
    this.setState({ oSName });
  }

  detectOs() {
    if (navigator.appVersion.indexOf('Win') !== -1) {
      return 'Windows';
    }
    if (navigator.appVersion.indexOf('iPhone') !== -1) {
      return 'Iphone';
    }
    if (navigator.appVersion.indexOf('Mac') !== -1) {
      return 'MacOS';
    }
    if (navigator.appVersion.indexOf('X11') !== -1) {
      return 'UNIX';
    }
    if (navigator.appVersion.indexOf('Android') !== -1) {
      return 'Android';
    }
    return 'Unknown';
  }

  render() {
    const i18n = this.props.lang.i18n;
    const detailsInfo = this.props.detailsInfo;
    let BtnApp = <Button className="button--alternative" onClick={this.sendAppLink} text={i18n('onboarding.summary.buttonTextWindows')} />;
    if (this.state.oSName === 'Android') {
      BtnApp = (
        <Button
          className="button--alternative"
          icon="play-store"
          href="http://onelink.to/bq2tev"
          onClick={this.handleClickOnGooglePlayButton}
          text={i18n('onboarding.summary.buttonTextAndroid')}
        />
      );
    } else if (this.state.oSName === 'Iphone') {
      BtnApp = (
        <Button
          className="button--alternative"
          icon="apple-store"
          href="http://onelink.to/bq2tev"
          onClick={this.handleClickOnGooglePlayButton}
          text={i18n('onboarding.summary.buttonTextIphone')}
        />
      );
    }

    return (
      <div className="summary text-center">
        <Title text={i18n('onboarding.summary.title')} className="form__title mb-5" />
        <div className="mb-4">
          <img src={DancingGran} alt="Loading" title="Loading" className="mb-5 pb-2" />
          <div className="row justify-content-center">
            <div className="col-8 col-sm-12">
              <h3 className="font-weight-bold text-large mb-3">
                {detailsInfo && detailsInfo.get('startDate')
                  ? `${i18n('onboarding.summary.secondaryTitle1')} ${detailsInfo.get('startDate')}`
                  : i18n('onboarding.summary.secondaryVirtualTitle')}{' '}
                {i18n('onboarding.summary.secondaryTitle2')}
              </h3>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-9 col-sm-5">
              <p className="mb-0">{i18n('onboarding.summary.description')}</p>
            </div>
          </div>
        </div>
        {BtnApp}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  userDetails: getUserDetails(state),
  token: getAuthToken(state),
  detailsInfo: getDealInfo(state),
  lang: state.lang
});

export default connect(mapStateToProps)(Summary);



// WEBPACK FOOTER //
// ./src/components/Views/Onboarding/Steps/Summary.js